import { AppProviders } from "@app/ui/providers";

export function App() {
  return <AppProviders />;
}
